<template>
  <div>
    <!-- <div class="back-box">
      <div class="back-item flexcolumn flexcenter" @click="handleSuggest">
        <div class="back-item-icon">
          <i class="iconfont icon-tousu"></i>
        </div>
        <div class="back-item-text">投诉建议</div>
      </div>
      <div class="back-item flexcolumn flexcenter" @click="handleRecruit">
        <div class="back-item-icon">
          <i class="iconfont icon-zhaomuXX"></i>
        </div>
        <div class="back-item-text">服务商招募</div>
      </div>
      <div class="back-item flexcolumn flexcenter" @click="handleContact">
        <div class="back-item-icon">
          <i class="iconfont icon-lianxiwomen"></i>
        </div>
        <div class="back-item-text">联系我们</div>
      </div>
    </div> -->
    <el-backtop :bottom="100">
      <div class="back-box back-top flexcolumn">
        <div class="back-item flexcolumn flexcenter">
          <div class="back-item-icon">
            <i class="iconfont icon-zhiding"></i>
          </div>
          <div class="back-item-text">返回顶部</div>
        </div>
      </div>
    </el-backtop>
  </div>
</template>

<script>
import { openCustomerServicee } from "../../utils/buildExternalUrl";
export default {
  props: {},
  data() {
    return {};
  },
  computed: {},
  created() {},
  mounted() {},
  beforeDestroy() {},
  watch: {},
  methods: {
    //联系我们
    handleContact(e) {
      //阻止组件默认事件
      e.stopPropagation();
      openCustomerServicee();
    },
    //投诉建议
    handleSuggest(e) {
      e.stopPropagation();
      openCustomerServicee();
    },
    //服务商招募
    handleRecruit(e) {
      e.stopPropagation();
      this.$router.push({
        path: "/articleDatails",
        query: {
          id: "343",
        },
      });
    },
  },
  components: {},
};
</script>

<style scoped lang="scss">
.back-box {
  position: fixed;
  right: 2px;
  bottom: 174px;
  background-color: #fff;
  color: #2a2a2a;
  font-size: 0.875rem;
  box-shadow: -3px 0px 20px 1px rgba(111, 142, 188, 0.16);
  border-radius: 2px;
  cursor: pointer;
  .back-item {
    width: 96px;
    height: 74px;
    &:hover {
      background: #e9f3ff;
    }
    .back-item-icon {
      .iconfont {
        font-size: 30px;
      }
    }
  }
  .twoTHeight {
    height: 148px;
  }
}
.back-top {
  bottom: 100px !important;
}
</style>
